/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'calendar': {
    width: 16,
    height: 16,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M27 5h-3V2h-3v3H11V2H8v3H5c-1.1 0-2 .9-2 2v19c0 1.1.9 2 2 2h22c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zM5 26V9h22v17H5z"/><path pid="1" d="M12 11h3v3h-3zM17 11h3v3h-3zM22 11h3v3h-3zM22 16h3v3h-3zM17 16h3v3h-3zM12 16h3v3h-3zM7 16h3v3H7zM7 21h3v3H7zM12 21h3v3h-3zM17 21h3v3h-3z"/>'
  }
})
